import React from 'react';
import { getHighlightString } from '../utills';
import styles from './common.scss';

const SearchText = ({ text, search = '', className = '', containerClass, attachmentPresent, readOnlyProduct }) => {
	const results = getHighlightString({
		searchKey: search,
		searchResult: text,
		className: styles['search-highlight']
	});
	return (
		<div className={containerClass}>
			<span className={className} dangerouslySetInnerHTML={{ __html: results }} />
			{attachmentPresent ?	
                <span className={`icon-Gl_Attachment ${readOnlyProduct ? 'icon-padding' : ''}`}></span> : null 
            } 
		</div>
	);
};

export default SearchText;
